<template>
	<div v-if="theVideoId !== null" class="video__container">
		<vimeo-player id="timeline-player"
									class="video video--vimeo"
									:title="theVideoTitle"
									ref="timelinePlayer"
									:video-id="theVideoId"
									controls="controls"
									loop="loop"
									muted="muted"
									@ready="onReady" />
	</div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { vueVimeoPlayer as VimeoPlayer } from 'vue-vimeo-player'
import { useI18n } from '#imports'
const { locale } = useI18n()
const props = defineProps({
  content: Object
})
const timelinePlayer = ref('null')
let theVideoId
let theVideoTitle
const onReady = () => {
	timelinePlayer.value.playerReady = true
}
if(props.content.video !== null) {
	theVideoId = computed(() => locale.value === 'en' ? props.content.video.en : props.content.video.jp)
}
if(props.content.title !== null) {
	theVideoTitle = computed(() => locale.value === 'en' ? props.content.title.en : props.content.title.jp)
}
onMounted(() => {
	const play = () => {
		timelinePlayer.value.mute()
		timelinePlayer.value.play()
	}
	const pause = () => {
		timelinePlayer.value.pause()
	}
  if (process.client) {
    gsap.registerPlugin(ScrollTrigger);
  }
  gsap.to(timelinePlayer.value.elementRef,
    {
      scrollTrigger: {
        start: "top center",
        trigger: timelinePlayer.value.elementRef,
        onEnter: self => {
        	play()
				},
				onEnterBack: self => {
					play()
				},
				onLeave: self => {
					pause()
				}
      }
    }
	)
})
</script>

<style lang="scss">
.video__container {
  display: block;
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
	margin: 0;
  max-width: 100%;

  .video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
